/* eslint-disable @typescript-eslint/naming-convention */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { UnitType, DynamicRequirementInputsIds } from 'src/api';
import { ConceptInputComponent } from '../../../forms/input/concept-input.component';
import { ComponentWidth, FlexLayout } from '@ansys-internal/awc-angular/core';
import { AWCListItem } from '@ansys-internal/awc-angular/lists';
import { ConfigurationsService } from 'src/app/shared/services/configurations.service';
import {
  LabelPosition,
  SelectComponent,
  SwitchComponent,
  SwitchSize,
  InputType,
} from '@ansys-internal/awc-angular/forms';
import { ArchitectureService } from '../../../../../shared/services/architecture.service';
import { CommonModule } from '@angular/common';
import {FormSelectComponent} from "@ansys-internal/awc-angular/form-select";
import {AWCFormElementSize} from "@ansys-internal/awc-angular/form";

export type SetPart = [value: string, type: string, id: string, index?: number];

@Component({
    selector: 'app-dynamic-requirements-inputs',
    templateUrl: './dynamic-requirements.component.html',
    styleUrls: ['../inputs.scss'],
    imports: [
        ConceptInputComponent,
        SwitchComponent,
        CommonModule,
        FormSelectComponent,
    ]
})
export class DynamicRequirementsComponent implements OnInit {
  @Input() part!: DynamicRequirementInputsIds;
  @Input() update!: boolean;
  @Output() setPart: EventEmitter<SetPart> = new EventEmitter<SetPart>();
  @Output() forceUpdate: EventEmitter<string> = new EventEmitter<string>();
  protected UnitType = UnitType;
  protected InputTypes = InputType;
  protected layout: FlexLayout = FlexLayout.COLUMN;
  protected aerodynamics: AWCListItem[] = [];
  protected masses: AWCListItem[] = [];
  protected wheels: AWCListItem[] = [];

  protected selectedAero: string[] = [];
  protected selectedMass: string[] = [];
  protected selectedWheel: string[] = [];
  protected labelPosition: LabelPosition = LabelPosition.BEFORE;
  protected size: SwitchSize = SwitchSize.MEDIUM;
  protected awcSizing: ComponentWidth = ComponentWidth.FILL;
  protected awcTooltip: string = 'Include Losses';
  protected axleSplitStrategies: AWCListItem[] = [
    {
      id: 'max_efficiency',
      text: 'Max Efficiency',
    },
    {
      id: 'fixed',
      text: 'Fixed',
    },
  ];
  protected axleSplitStrategy: string = this.axleSplitStrategies[0].id;

  constructor(
    private configurationService: ConfigurationsService,
    protected architecture: ArchitectureService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    [this.aerodynamics, this.masses, this.wheels] =
      this.configurationService.configurationLists.map((list) => {
        return list.map((item) => {
          return { ...item };
        });
      });
    this.selectedAero = [
      this.part.aero_id ?? (this.aerodynamics?.[0]?.id || ''),
    ];
    this.part.aero_id = this.selectedAero[0];
    this.selectedMass = [this.part.mass_id ?? (this.masses?.[0]?.id || '')];
    this.part.mass_id = this.selectedMass[0];
    this.selectedWheel = [this.part.wheel_id ?? (this.wheels?.[0]?.id || '')];
    this.part.wheel_id = this.selectedWheel[0];

    if (
      this.part.front_axle_split !== null &&
      this.part.front_axle_split !== undefined
    ) {
      this.axleSplitStrategy = this.axleSplitStrategies[1].id;
    }
  }

  protected selectionIDSet($event: string, type: string): void {
    this.part[type as keyof DynamicRequirementInputsIds] = $event as never;
    this.forceUpdate.emit('');
  }

  protected toggleMC($event: boolean): void {
    this.part.max_capability = $event;
    this.forceUpdate.emit('');
  }

  protected changeAxleSplitStrategy($event: string): void {
    this.axleSplitStrategy = $event;
    if (this.axleSplitStrategy === this.axleSplitStrategies[0].id) {
      this.part.front_axle_split = null;
    }
    this.forceUpdate.emit('');
  }

  protected readonly AWCFormElementSize = AWCFormElementSize;
}
